var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrowFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 4,
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.81567 3.43015L0.951944 5.86584C0.550964 6.20688 -2.75873e-08 5.85833 -3.21881e-08 5.26362L-6.72114e-08 0.736377C-7.18122e-08 0.141665 0.550965 -0.206883 0.951945 0.134162L3.81568 2.56985C4.06144 2.77888 4.06144 3.22112 3.81567 3.43015Z",
    fill: "#041E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowFaqs);
export default __webpack_public_path__ + "static/media/left-arrow-faqs.5ecf92c07cdb29f9fa54e616275c2173.svg";
export { ForwardRef as ReactComponent };